module.exports = __webpack_public_path__ + "img/10.6534b34b.jpg";